import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=15c7421e&"
import script from "./SearchItem.vue?vue&type=script&lang=ts&"
export * from "./SearchItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports